import { Box } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { TooltipProps } from "@mui/material/Tooltip";

import styles from "../../../../assets/styles/componentStyles/billingStyles/billingUsage.module.scss";

import GlobalTooltip from "../../../utility/tooltip/globalTooltip";

interface FeatureFreezeWarningProps {
    placement?: TooltipProps["placement"];
    size?: "default" | "small" | "medium";
}

const FeatureFreezeWarning = ({ placement = "left", size = "default" }: FeatureFreezeWarningProps) => {
    return (
        <GlobalTooltip
            title={
                <>
                    Your feature has been paused. Please contact the {" "}
                        <a className={styles.headerFreezedLink} href='https://chronox.ai/contact-us' target='_blank' rel='noopener noreferrer'>
                            Chronox support
                        </a> 
                    {" "} team for help.
                </>
            }
            arrow
            placement={placement}
        >
            <Box className={styles.headerFreezed}>
                <WarningAmberIcon
                    className={size === "small" ? styles.headerFreezedIconSmall : size === "medium" ? styles.headerFreezedIconMedium : styles.headerFreezedIcon}
                />
            </Box>
        </GlobalTooltip>
    );
};

export default FeatureFreezeWarning;
